import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { BtwButton } from '@marvelapp/ballpark-components';
import { FireIcon } from '@marvelapp/ballpark-icons';
export const HeatmapsButton = observer(function HeatmapsButton(props) {
    return (_jsx(BtwButton, Object.assign({ "data-testid": "open-heatmaps", leadingIcon: _jsx(FireIcon, {}) }, props, { children: "Heatmaps" })));
});
